import {
  LOAD_API_TRANSPORT_INFO_DATA,
  LOAD_API_TRANSPORT_INFO_DATA_FAILED,
  LOAD_API_TRANSPORT_INFO_DATA_SUCCESS,
} from "../types"

const initialState = {
  providers: [],
  loading: false,
  error: false,
}

export default function (state = initialState, action) {
  switch (action.type) {
    case LOAD_API_TRANSPORT_INFO_DATA:
      return {
        ...state,
        loading: true,
        error: false,
        providers: [],
      }
    case LOAD_API_TRANSPORT_INFO_DATA_FAILED:
      return {
        ...state,
        loading: false,
        error: true,
        providers: [],
      }
    case LOAD_API_TRANSPORT_INFO_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        providers: action.payload,
      }
    default:
      return state
  }
}
